import { createSlice } from "@reduxjs/toolkit";

const initialState = {};

const studygroupSlice = createSlice({
  name: "studygroup",
  initialState,
  // reducers: {},
});

// export const { userLoggedIn, userLoggedOut } = userSlice.actions
export default studygroupSlice.reducer;
